import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

import { SettingContainer } from "./component/styled/setting";

import OptionGroup from "./component/setting/optionGroup";
import MenuGroup from "./component/setting/menuGroup";
import MenuBoard from "./component/setting/menuBoard";
import Company from "./component/setting/company";
import BizTime from "./component/setting/bizTime";

import SideMenu from "./component/common/sideMenu";
import MediaViewer from "../../../common/mediaViewer";

import CompanyInfo from "./component/setting/companyInfo";

const Setting = ({
  selectCompany,
  stores,
  openModal,
  closeModal,
  active,
  setActive,
  getCompany,
  currentAuth,
  company,
}) => {
  const [domain, setDomain] = useState("");
  const [products, setProducts] = useState([]);
  const [optionGroup, setOptionGroup] = useState([]);
  const [menuGroups, setMenuGroups] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoriesObj, setCategoriesObj] = useState({});
  const [info, setInfo] = useState({ image: [], text: null });
  const [imageOrder, setImageOrder] = useState([]);
  const [isDetail, setIsDetail] = useState(false);
  const [badges, setBadges] = useState({});

  const tabs = ["company", "bizTime", "info"].includes(active)
    ? { company: "회사정보수정", bizTime: "영업시간", info: "매장안내" }
    : { menuBoard: "메뉴판관리", menuGroup: "메뉴그룹", option: "옵션그룹" };

  useEffect(() => {
    if (!selectCompany) return;
    fetchInitialData();
  }, [selectCompany]);

  // 도메인 체크
  const checkDomain = async () => {
    const url = "/api/domainSettingLoad";
    const body = { cmpnyNo: selectCompany.value, delYn: "N" };

    try {
      const res = await axios.post(url, body);
      setDomain(res?.data?.domain || "");
    } catch (error) {
      console.log(error);
    }
  };

  // 초기 데이터 조회
  const fetchInitialData = async () => {
    try {
      Promise.all([
        getProducts(),
        getOptions(),
        getMenuGroup(),
        checkDomain(),
        getCategory(),
        getBadges(),
      ]);
    } catch (error) {
      console.error("초기 데이터 로딩 실패", error);
    }
  };

  // 탭 변경 시 데이터 조회
  useEffect(() => {
    fetchData();
  }, [active]);

  const fetchData = () => {
    const actions = {
      menuBoard: () => {
        // getCompany(selectCompany.value);
      },
      menuGroup: () => getMenuGroup(),
      option: () => getOptions(),
    };

    actions[active]?.();
    getProducts();
  };

  // 카테고리 목록 요청 및 정렬/객체화
  const getCategory = async () => {
    try {
      const res = await axios.post("/api/categories");
      if (res.status === 200) {
        const data = res?.data || [];

        setCategories(sortCategories(data));
        setCategoriesObj(
          data.reduce((acc, ele) => {
            acc[ele.categoryId] = ele.categoryName;
            return acc;
          }, {}),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 연동된 상품 조회
  const getProducts = async () => {
    try {
      const url = "/erp/vendorProducts/get";
      const query = `
      query VendorProducts(
        $cmpnyNo: Int!
      ) {
        vendorProducts(
          filter: {
            cmpnyNo: $cmpnyNo
          }
        ) {
          products {
            id
            name
            media
            price
            quantity
            categoryId
            description
            specifications
            useDisplay
            status
            shortDescription
            tags
            brand
            cloudProduct {
                id
            }
          }
        }
      }
    `;
      const variables = { cmpnyNo: parseInt(selectCompany.value, 10) };
      const body = { query, variables };

      const res = await axios.post(url, body);
      if (res.status === 200) {
        setProducts(res.data.products);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 옵션 그룹 목록 조회
  const getOptions = async () => {
    const url = "/erp/optionGroup/get";
    const res = await axios.post(url, { cmpnyNo: selectCompany.value });

    try {
      if (res.status === 200) {
        setOptionGroup(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // 메뉴 그룹 목록 요청 및 정렬
  const getMenuGroup = async () => {
    try {
      const url = "/erp/menuGroup/get";
      const body = { cmpnyNo: selectCompany.value, menuPlatform: "PICKUP", admin: true };
      const res = await axios.post(url, body);

      if (res.status) {
        const data = res?.data || [];
        setMenuGroups(
          [...data].sort((a, b) => {
            if (a.sortOrder !== b.sortOrder) {
              return a.sortOrder - b.sortOrder;
            }
            return Number(b.id) - Number(a.id);
          }),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const clickImages = (arr, index) => {
    const reorderedImages = [...arr.slice(index, arr.length), ...arr.slice(0, index)];
    setImageOrder(reorderedImages);
    setIsDetail(true);
  };

  const renderComponent = () => {
    switch (active) {
      case "menuBoard":
        return (
          <MenuBoard
            menuGroups={menuGroups}
            setActive={setActive}
            info={info}
            clickImages={clickImages}
            company={company}
            badges={badges}
            selectCompany={selectCompany}
          />
        );
      case "menuGroup":
        return (
          <MenuGroup
            selectCompany={selectCompany}
            menuGroups={menuGroups}
            openModal={openModal}
            closeModal={closeModal}
            products={products}
            getMenuGroup={getMenuGroup}
            domain={domain}
            clickImages={clickImages}
            getProducts={getProducts}
            categoriesObj={categoriesObj}
            categories={categories}
            optionGroup={optionGroup}
          />
        );
      case "option":
        return (
          <OptionGroup
            selectCompany={selectCompany}
            openModal={openModal}
            closeModal={closeModal}
            optionGroup={optionGroup}
            getOptions={getOptions}
            products={products}
          />
        );
      case "company":
        return (
          <Company
            info={info}
            clickImages={clickImages}
            setActive={setActive}
            openModal={openModal}
            closeModal={closeModal}
            badges={badges}
            currentAuth={currentAuth}
            company={company}
            getCompany={getCompany}
            selectCompany={selectCompany}
          />
        );
      case "bizTime":
        return (
          <BizTime
            company={company}
            setActive={setActive}
            selectCompany={selectCompany}
            openModal={openModal}
            closeModal={closeModal}
            getCompany={getCompany}
          />
        );
      case "info":
        return (
          <CompanyInfo
            company={company}
            setActive={setActive}
            selectCompany={selectCompany}
            openModal={openModal}
            closeModal={closeModal}
            getCompany={getCompany}
          />
        );
    }
  };

  // 전체 뱃지 조회
  const getBadges = async () => {
    const url = "/api/badge/get";
    try {
      const res = await axios.post(url, { keyword: "" });
      if (res.status === 200) {
        if (res.status === 200) {
          const obj = (res.data || []).reduce((acc, badge) => {
            acc[badge.id] = badge.name;
            return acc;
          }, {});
          setBadges(obj);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <SettingContainer className="container">
      {imageOrder && imageOrder.length > 0 && isDetail && (
        <MediaViewer files={imageOrder} setIsOpen={setIsDetail} />
      )}
      <SideMenu tabs={tabs} active={active} setActive={setActive} type="setting" />
      <div className="content setting">
        <div className="viewer">{renderComponent()}</div>
      </div>
    </SettingContainer>
  );
};

export default Setting;
